import { useRouter } from 'expo-router';
import { useEffect } from 'react';
import { ActivityIndicator, View } from 'react-native';
import { useAuth } from '../src/contexts/AuthContext';
import { RegulatoryDocsPanel } from '../src/features/voice-agents/components/RegulatoryDocsPanel';
import { colors } from '../src/theme/colors';

export default function VoiceRegulatoryDocsRoute() {
  const router = useRouter();
  const { isAuthenticated, isLoading, currentOrganization } = useAuth();

  useEffect(() => {
    if (!isLoading && !isAuthenticated) router.replace('/login');
  }, [isAuthenticated, isLoading, router]);

  if (isLoading) {
    return (
      <View
        style={{
          flex: 1,
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: colors.background.primary,
        }}
      >
        <ActivityIndicator color={colors.primary.main} size="large" />
      </View>
    );
  }

  if (!currentOrganization) return null;

  return <RegulatoryDocsPanel organizationId={currentOrganization.id} />;
}
